import React, {memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {useSelector} from "react-redux"
import {SliderProps} from "@mui/material"
import type State from "../../../models/State"

const PriceSlider = memo((props: SliderProps) => {
    const template = useSelector((state: State) => state.template)
    const ComponentName = useTemplatedComponent(template, MANIFEST)

    return <ComponentName {...props} />
})
PriceSlider.displayName = "PriceSlider"
export default PriceSlider
